 "use client";

import { InferRequestType, InferResponseType } from "hono";
import { useMutation } from "@tanstack/react-query";

import { client } from "@/lib/hono";
import toast from "@/lib/toast";

type ResponseType = InferResponseType<
    (typeof client.api.storage)["lomda-v2"][":lomdaId"]["$patch"],
    200
>;
type RequestType = InferRequestType<
    (typeof client.api.storage)["lomda-v2"][":lomdaId"]["$patch"]
>["json"];

export const useUpdateLomdaV2 = (lomdaId: string) => {
    return useMutation<ResponseType, Error, RequestType>({
        mutationKey: ["lomda-v2", { lomdaId }],
        mutationFn: async (json) => {
            const response =
                await client.api.storage["lomda-v2"][":lomdaId"].$patch({
                    param: { lomdaId },
                    json,
                });

            if (!response.ok) {
                throw new Error("Failed to update lomda");
            }

            return response.json();
        },
        onError: (error) => {
            console.error("Error updating lomda:", error);
            toast.error("Failed to update lomda");
        },
    });
};
